import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import QuButton from '@quiqupltd/qu-react-sdk/lib/components/qu-button';

export const RateDisclaimer = styled.p`
  color: ${props => props.theme.grey};
  text-align: center;
`;

export const RateExperience = ({ onClick }) => {
  return (
    <div>
      <QuButton type="flat-primary" fluid onClick={onClick}>
        Rate your delivery experience
      </QuButton>
      <RateDisclaimer>
        We are always looking to improve our services,
        <br />
        let us know how we did.
      </RateDisclaimer>
    </div>
  );
};

RateExperience.propTypes = {
  onClick: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/app/order-card/completed/rate-experience/rate-experience.js